"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.canTransfer = exports.getBusinessAuditHeaders = exports.isProduction = exports.dropdownMap = void 0;
var AuditLogs_1 = require("@src/constants/AuditLogs");
var BotActions_1 = require("@src/actions/BotActions");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
var constants_1 = require("./constants");
exports.dropdownMap = function (array) {
    return Object.keys(array).map(function (key) { return ({
        id: key,
        value: array[key],
    }); });
};
exports.isProduction = function () { return process.env.ENV_NAME === 'production'; };
/**
 * Gets audit headers for transfer of business
 * @param id id of the business
 * @param eventName event name to send
 * @param activePartners active partners of the business
 */
function getBusinessAuditHeaders(id, eventName, activePartners) {
    var headers = __assign({}, AuditLogs_1.AUDIT_LOGS_HEADERS);
    headers = __assign(__assign({}, headers), { 'x-haptik-business-id': id, 
        // by default we select the first active partner
        'x-haptik-partner-name': activePartners.length ? activePartners[0] : '', 'x-haptik-event-type': eventName });
    return headers;
}
exports.getBusinessAuditHeaders = getBusinessAuditHeaders;
/**
 * Checks whether user can transfer or not
 * @param transferGroups all the groups we want to transfer
 */
function canTransfer(transferGroups) {
    if (transferGroups.indexOf(constants_1.TRANSFER_TYPE.BUSINESS) !== -1 ||
        transferGroups.indexOf(constants_1.TRANSFER_TYPE.TASK) !== -1) {
        // Verify Business/Task transfer checks
        if (!BotActions_1.userHasPermission(const_1.PERMISSION_LEVELS.BUSINESS_TASK_EDIT_TRANSFER)) {
            MogamboConstants_1.permissionErrorAlert('publish Business Task');
            return false;
        }
    }
    if (transferGroups.indexOf(constants_1.TRANSFER_TYPE.TRIGGER) !== -1) {
        // Verify trigger transfer checks
        if (!BotActions_1.userHasPermission(const_1.PERMISSION_LEVELS.BUSINESS_PROMPT_TRIGGER_EDIT_TRANSFER)) {
            MogamboConstants_1.permissionErrorAlert('publish bot prompt triggers');
            return false;
        }
    }
    return true;
}
exports.canTransfer = canTransfer;
